/**
 * Clean command from the message
 */
export const cleanCommand = ({ command, value }) =>
  value.ops[0].insert.replace(`/${command}`, '').trim();
